import * as types from './sidebar.actionType';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  selectedItens: [],
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.SET_SELECTED:
      return state.merge({ selectedItens: action.payload });
    default:
      return state;
  }
}
